module.exports = __webpack_public_path__ + "static/media/egenradig.728f3bb2.m4a";